import type { FC } from 'react';
import clsx from 'clsx';

import { MdCallEnd } from 'react-icons/md';

import { OPopper } from '@src/shared';
import {
  useLeaveMeetingPopper,
  type TMenuItemConfig,
} from '@src/containers/RoomFooter/screen/RoomFooterWeb/partials/LeaveMeetingPopper/useLeaveMeetingPopper';

import style from './leaveMeetingPopper.module.scss';

interface ILeaveMeetingPopperProps {
  pipWindow?: Window;
}

const LeaveMeetingPopper: FC<ILeaveMeetingPopperProps> = ({ pipWindow }) => {
  const { isActive, setIsActive, menuItems } = useLeaveMeetingPopper(pipWindow);

  return (
    <OPopper
      tooltipContent="Leave meeting"
      icon={
        <div className={clsx('icon-container', 'red', { active: isActive })}>
          <MdCallEnd />
        </div>
      }
      onClose={() => setIsActive(false)}
      onOpen={() => setIsActive(true)}
      offset={[0, 10]}
      classes={{
        containerStyle: style.container,
      }}
      customStyles={{
        width: 209,
        root: {
          border: 'none',
          borderRadius: '16px',
        },
        boxRoot: {
          width: '209px',
          height: '110px',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          opacity: 1,
          padding: '0',
          display: 'flex',
          flexDirection: 'column',
          gap: '0',
        },
      }}
    >
      <div className={style.container}>
        {menuItems.flatMap((item: TMenuItemConfig, index: number) => [
          <button
            key={item.id}
            id={item.id}
            type="button"
            onClick={item.onClick}
            className={clsx(item.className, style.item)}
          >
            {item.icon}
            {item.label}
          </button>,
          index === 0 && menuItems.length > 1 ? <div key="separator" className={style.separator} /> : null,
        ])}
      </div>
    </OPopper>
  );
};

export default LeaveMeetingPopper;
